// extracted by mini-css-extract-plugin
export default {"orange_link":"TextLink_orange_link__Boxqn"};